import dayjs from "dayjs";
import formatPrice from "helpers/formatPrice";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import {
  filter_invoice_statuses,
  getInvoiceStatusTag,
} from "helpers/options/invoice_statuses";
import { Typography } from "antd";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    sortable: true,
    searchable: true,
    search_method: "eq",
    render: (_, { id }) => (
      <Link to={`/billings/${id}`}>
        <Typography.Text strong>{id}</Typography.Text> <EditOutlined />
      </Link>
    ),
  },
  {
    title: "Okres rozliczeniowy",
    dataIndex: "period_start",
    sortable: true,
    searchable: true,
    search_method: "date-month",
    search_component: "month-picker",
    render: (_, { period_start, period_end }) =>
      period_start
        ? `${dayjs(period_start).format("DD")} - ${dayjs(period_end).format(
            "DD MMMM YYYY"
          )}`
        : "-",
  },
  {
    title: "Ilość zgłoszeń",
    dataIndex: "billed_issues_count",
    sortable: true,
    render: (_, { billed_issues_count }) => (
      <Typography.Text strong>{billed_issues_count || 0}</Typography.Text>
    ),
  },
  {
    title: "Cena za zgłoszenie",
    dataIndex: "single_issue_fee",
    sortable: true,
    render: (_, { single_issue_fee, currency }) => (
      <>{formatPrice(single_issue_fee, currency)}</>
    ),
  },
  {
    title: "Koszt zgłoszeń",
    dataIndex: "usage_fee",
    sortable: true,
    render: (_, { usage_fee, currency }) => (
      <>{formatPrice(usage_fee, currency)}</>
    ),
  },
  {
    title: "Abonament",
    dataIndex: "base_fee",
    sortable: true,
    render: (_, { base_fee, currency }) => (
      <>{formatPrice(base_fee, currency)}</>
    ),
  },
  {
    title: "Kwota całkowita",
    dataIndex: "total_amount",
    sortable: true,
    render: (_, { total_amount, currency }) => (
      <Typography.Text strong>
        {formatPrice(total_amount, currency)}
      </Typography.Text>
    ),
  },
  {
    title: "Status",
    dataIndex: "invoice_status",
    sortable: true,
    searchable: true,
    search_method: "in",
    search_component: "select",
    options: filter_invoice_statuses,
    render: (_, { invoice }) => getInvoiceStatusTag(invoice?.status),
    width: 150,
  },
];

export default columns;
